import { Link } from 'react-router-dom'
import type { PlatformFeeProgram } from '../../api/payouts'

export default function ProsPlatformFeeTab({ program }: { program: PlatformFeeProgram | null }) {
  if (!program) {
    return (
      <div className="rounded-2xl border border-white/10 bg-white/5 p-5 text-sm text-white/70">
        Platform fee program details are unavailable right now.
      </div>
    )
  }

  const reqTotal = program.requirements?.length || 0
  const reqMet = (program.requirements || []).filter((row) => row.met).length

  return (
    <div className="space-y-4">
      <div className="rounded-2xl border border-white/10 bg-white/5 p-5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <div className="text-xs uppercase tracking-[0.14em] text-white/55">Platform Fee Program</div>
            <div className="mt-1 text-sm text-white/90">
              Your platform fee: <span className="font-semibold">{program.active.fee_percent || '10.00'}%</span> (locked)
            </div>
            <div className="mt-1 text-sm text-white/75">
              Next: {program.target_next?.tier_name || 'Max tier reached'} ({program.target_next?.fee_percent || program.active.fee_percent || '-'}%)
            </div>
            <div className="mt-1 text-xs text-white/65">
              {reqTotal > 0 ? `${reqMet} of ${reqTotal} requirements met` : 'Max tier reached'}
            </div>
          </div>
          <Link to="/settings/creator-tools/platform-fee" className="rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm font-semibold text-white hover:bg-white/10">
            View details
          </Link>
        </div>
      </div>

      <div className="rounded-2xl border border-white/10 bg-white/5 p-4 text-sm text-white/80">
        Reduce your platform fee by meeting trust and activity requirements.
      </div>
    </div>
  )
}

